import { render, staticRenderFns } from "./CotPropostaAccessoEditComponent.vue?vue&type=template&id=4cb9112a"
import script from "./CotPropostaAccessoEditComponent.vue?vue&type=script&lang=js"
export * from "./CotPropostaAccessoEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports